$(document).ready(function () {
  $('.category-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1.5
      },
      565: {
        items: 3
      },
      767: {
        items: 3.5
      },
      992: {
        items: 5
      },

    }
  });
  $('.recommendation-carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    smartSpeed: 1000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2
      },
      565: {
        items: 3
      },
      992: {
        items: 3
      },
      1024: {
        items: 4
      },
      1200: {
        items: 5
      },
      1800:{
        items: 6
      }
    }
  });
  $('.banners-carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    smartSpeed: 1000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      767: {
        items: 2
      }
    }
  });

  // RANGE DESCRIPTION SECTION STARTS
  $('.toggle-range-description').click(function() {
    if($('.toggle-para').hasClass('disabled')){
      $('.toggle-para').removeClass('disabled');
      $(this).html('Close');
    }
    else{
      $('.toggle-para').addClass('disabled');
      $(this).html('Read More');
    }
  });

  // LEAGUE MOBILE SECTION STARTS 
  $('.league-btn').click(function() {
    if($(this).parents('.accordion-item').find('.accordion-item-body').hasClass('collapsed')){
      $(this).parents('.accordion-item').find('.accordion-item-body').removeClass('collapsed');
      $(this).find('.btn-icon').html('-');
    }
    else{
      $(this).parents('.accordion-item').find('.accordion-item-body').addClass('collapsed');
      $(this).find('.btn-icon').html('+');
    }
  })
});